import { combineReducers } from 'redux'
import { createReducer } from 'helpers/ReducerUtil'
import {
  CLEAR,
  APPROVAL_TYPE,
  APPROVE_TYPE,
  UPDATE_COMMENT,
  UPDATE_ACTIVE,
  UPDATE_TYPE,
  UPDATE_DIALOG_TYPE,
  UPDATE_WORKFLOW_ID,
  UPDATE_PROJECT_ID,
  UPDATE_SKIPABLES
} from './constants'

const resetType = () => APPROVE_TYPE.SUBMIT.value
const resetDialogType = () => APPROVAL_TYPE.APPROVE
const resetActive = () => false
const resetComment = () => ''
const resetWorkflowId = () => null
const resetProjectId = () => null
const resetSkipables = () => ({})
const updateComment = (prev, { comment }) => comment
const updateActive = (prev, { active }) => active
const updateType = (prev, { value }) => value
const updateDialogType = (prev, { value }) => value
const updateWorkflowId = (prev, { id }) => id
const updateProjectId = (prev, { id }) => id
const updateSkipables = (prev, { skipables }) => skipables

const commentReducer = createReducer(resetComment(), {
  [CLEAR]: resetComment,
  [UPDATE_COMMENT]: updateComment,
})

const activeReducer = createReducer(resetActive(), {
  [UPDATE_ACTIVE]: updateActive,
})

const typeReducer = createReducer(resetType(), {
  [CLEAR]: resetType,
  [UPDATE_TYPE]: updateType,
})

const dialogTypeReducer = createReducer(resetDialogType(), {
  [CLEAR]: resetDialogType,
  [UPDATE_DIALOG_TYPE]: updateDialogType,
})

const workflowIdReducer = createReducer(resetWorkflowId(), {
  [CLEAR]: resetWorkflowId,
  [UPDATE_WORKFLOW_ID]: updateWorkflowId,
})

const projectIdReducer = createReducer(resetProjectId(), {
  [CLEAR]: resetProjectId,
  [UPDATE_PROJECT_ID]: updateProjectId,
})

const skipablesReducer = createReducer(resetSkipables(), {
  [CLEAR]: resetSkipables,
  [UPDATE_SKIPABLES]: updateSkipables
})

export default combineReducers({
  comment: commentReducer,
  active: activeReducer,
  type: typeReducer,
  dialogType: dialogTypeReducer,
  workflowId: workflowIdReducer,
  projectId: projectIdReducer,
  skipables: skipablesReducer
})
